module.exports = __webpack_public_path__ + "media/mediaProfessionals/union-icon-f386aee4.png";